export class emptyConfiguration {
    public emptyContentText: String;
    public emptySearchText: String;
}